export default __webpack_public_path__ + "static/media/screenShots_blash-2.5f368fde.jpg";